import { c as _c } from "react/compiler-runtime";
import { APIWebhook } from '../../../../../../../../typings/Webhook.interface';
import Container from '../../../../common/base/Container';
import ResourceMetricSection from '../ResourceMetricsSection';
export const ConnectionMetrics = t0 => {
  const $ = _c(2);
  const {
    connection
  } = t0;
  let t1;
  if ($[0] !== connection.id) {
    t1 = <Container left={true}><ResourceMetricSection id={connection.id} resource="connections" default_relative_date="last_hour" /></Container>;
    $[0] = connection.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};